import React from "react";
import { Link } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import { SwiperSlide, Swiper } from "swiper/react";

function NojoomHotDealsShimmer(){
return(

  <Accordion.Item className="accordion_item accordion_style_1 " style={{background: "#f6f6f6"}}>
      <Accordion.Header className="accordion_header w-60" style={{padding: '25px 12px 20px 12px'}}>
          <h3 class="section_title mb-0 shimmer-h20 shimmerBG" style={{boxShadow: '0px 2px 14px 0px rgba(0, 0, 0, 0.1)'}}></h3>
        
      </Accordion.Header>

      <Accordion.Body className="accordion_collapse">
        <div style={{padding: '0px 12px 20px 12px'}}>
            <Swiper
              className="column_swiper_1"
              spaceBetween={12}
              slidesPerView={1.1}
              breakpoints={{
                768:{
                  slidesPerView: 1.8,
                },
                0:{
                  slidesPerView:1.8
                }
              }}
            >
              <SwiperSlide>
              <Link className="card_style_1 height_100 shimmer-effect " >
                <div className="card_img shimmerBG" style={{height:'164px', margin: '10px 10px 0px 10px'}}>
                </div>
                <div className="card_info text-center">
                  <div className="card_info_grp">
                    <h4 className="text-ellipsis shimmer-effect text-center shimmer-h25 shimmerBG " style={{margin: '0px auto 8px', width: '70%'}}></h4>
                    <p className="text-ellipsis shimmer-effect text-center shimmer-h20 shimmerBG " style={{margin: '0px auto 8px', width: '70%'}}></p>
                  </div>
                  <div className="card_link">
                    <Link  className="hyperlink text-ellipsis shimmer-effect text-center shimmer-h30 shimmerBG ">
                    </Link>
                  </div>
                </div>
              </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link className="card_style_1 height_100 shimmer-effect " >
                  <div className="card_img shimmerBG" style={{height:'164px', margin: '10px 10px 0px 10px'}}>
                  </div>
                  <div className="card_info text-center">
                    <div className="card_info_grp">
                      <h4 className="text-ellipsis shimmer-effect text-center shimmer-h25 shimmerBG" style={{margin: '0px auto 8px', width: '70%'}}></h4>
                      <p className="text-ellipsis shimmer-effect text-center shimmer-h20 shimmerBG" style={{margin: '0px auto 8px', width: '70%'}}></p>
                    </div>
                    <div className="card_link">
                      <Link  className="hyperlink text-ellipsis shimmer-effect text-center shimmer-h30 shimmerBG ">
                      </Link>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            </Swiper>
            <button
              className="custom_btn shimmerBG custom_btn_primary_outline btn_block shimmer-effect shimmer-button-lg" style={{boxShadow: '0px 2px 14px 0px rgba(0, 0, 0, 0.1)'}}
            >
            </button>
          </div>
      </Accordion.Body>
    </Accordion.Item>
    
)
}
export default NojoomHotDealsShimmer;